import Section from '@/components/Section'
import Title from '@/components/Title'
import Container from '@/components/Container'
import React from 'react'
import Button from '@/components/Button'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import MediaPhotosCard from '@/components/Cards/MediaPhotosCard'
import MediaVideoCard from '@/components/Cards/MediaVideoCard'
import { api } from '@/api'
import { arrayToChunks } from '@/utils'
import { usePage } from '@/hooks'
import { Media } from '@/interfaces/Media'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import { dataStates } from '@garpix/fetcher'
import style from './styles/news.module.scss'

const MediaSection = (): React.ReactElement => {
  const page = usePage()
  const { config } = page.init_state.global

  return (
    <Section id='media'>
      <Container>
        <Title type='h2' theme='h1' className={style.title}>
          Медиа
        </Title>
        <FetcherList
          isScrollTop={false}
          isHistoryPush={false}
          api={api.getMediaList}
        >
          {({ results, showMore, status, isNext }: IFetcherListResults<Media[]>) => {
            const resultChunks: Media[][] = arrayToChunks([...results], 3)
            return (
              <>
                <div className={style.media}>
                  {resultChunks.map((list, _) => {
                    return (
                      <div
                        key={`grid-${list[0].id}`}
                        className={style.media_grid}
                      >
                        {list.map((el) => {
                          return (
                            <React.Fragment key={el.id}>
                              {el.video === null
                                ? (
                                  <MediaPhotosCard
                                    title={el.name}
                                    image={el.picture}
                                    count={el.count}
                                    date={el.date_create}
                                    id={el.id}
                                    baseUrl={config.media_detail}
                                    className={style.media__item}
                                  />
                                  )
                                : undefined}
                              {typeof el.video === 'string' &&
                              el.video.length > 0
                                ? (
                                  <MediaVideoCard
                                    title={el.name}
                                    image={el.picture}
                                    id={el.id}
                                    baseUrl={config.media_detail}
                                    className={style.media__item}
                                  />
                                  )
                                : undefined}
                            </React.Fragment>
                          )
                        })}
                      </div>
                    )
                  })}
                </div>
                {status === dataStates.loading ? <BlockSpinner /> : undefined}
                {isNext
                  ? (
                    <Button disabled={status === dataStates.loading} onClick={showMore} size='large' wide outline>
                      Показать еще
                    </Button>
                    )
                  : undefined}
              </>
            )
          }}
        </FetcherList>
      </Container>
    </Section>
  )
}

export default MediaSection
